

























































import Vue from 'vue';

import { getUserProfile } from "../api/UserProfile";

interface Data {
  /**
   * 無料利用期間
   */
  isFreeTime: boolean;
}

export default Vue.extend({
  name: 'About',
  components: {
  },
  props: {
    logged: Boolean,
    mq: String,
  },
  data(): Data {
    return {
      /**
       * 無料利用期間
       */
      isFreeTime: false,
    }
  },
  async beforeRouteEnter(to, route, next) {
    // 現在ログインしているユーザのプロフィール取得
    let userProf = null;
    let free = false;

    try {
      userProf = await getUserProfile();
      free = userProf.isFreeTime;
    } catch (e) {
      // 未ログイン、何もしない
      console.log(e);
    }

    next(async (vm) => {
      // ログイン済み
      if (vm.$props.logged) {
        (vm.$data as Data).isFreeTime = free;
      }
    });
  },
  methods: {
    onPushPath(path: string) {
      this.$router.push(path, () => {}); // eslint-disable-line
      this.$emit('pushPath', path);
    },
  }
})
